<template>
    <div>
        <buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash" @exps="exps" @save="save"  @del="delall"
                    ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
				<wTable
						id="xpane-0"
						:data="dataSet"
						:loading="loading"
						queryData="RecCostViewInfo"
						:filter_language="['order_status','finance_status']"
						:filter_thousandth="['rec_cost_total']"
						:header="tableHeader"
						:option="tableOption"
						@edits="leftClick"
						@rowdblclick="openEdit"
						:row-class-name="tableRowClassName"
						ref="singleTable"
						:checkflg="false"
				></wTable>
			<!--<el-table
			id="xpane-0"
			:data="dataSet"
			ref="singleTable"
			v-loading="loading"
			:highlight-current-row="true"
			show-overflow-tooltip="true"
			border
			stripe
			size="mini"
			@row-click="leftClick"
			@row-dblclick="openEdit"
			:height="tableHeight "
			header-row-class-name="headerclass"
			style="width: 100%; margin-top:0px"
			>
<el-table-column show-overflow-tooltip prop="order_no" :label="$t('getapi[3102]')"></el-table-column>
<el-table-column show-overflow-tooltip prop="order_status" :label="$t('getapi[1861]')"></el-table-column>
<el-table-column show-overflow-tooltip prop="finance_status" :label="$t('getapi[1862]')"></el-table-column>
<el-table-column show-overflow-tooltip prop="just_year" :label="$t('getapi[7650]')" align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="just_month" :label="$t('getapi[7651]')" align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="rec_cost_total" :label="$t('getapi[7652]')" align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="create_person" :label="$t('getapi[1419]')"></el-table-column>
<el-table-column show-overflow-tooltip prop="create_date" :label="$t('getapi[7654]')">
    <template scope="scope">
    {{$limits.getDateType(scope.row.create_date)}}
    </template>
</el-table-column>
<el-table-column show-overflow-tooltip prop="modify_person" :label="$t('getapi[733]')"></el-table-column>
<el-table-column show-overflow-tooltip prop="modify_time" :label="$t('getapi[1210]')"></el-table-column>
<el-table-column show-overflow-tooltip prop="audit_person" :label="$t('getapi[4043]')"></el-table-column>
<el-table-column show-overflow-tooltip prop="audit_date" :label="$t('getapi[4059]')"></el-table-column>
<el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')"></el-table-column>
			</el-table>-->


                   

            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
				<div  style="float:right;position: relative;">
					<el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
				</div>
				<div class="btnnowrap">
					<el-button type="primary" size="mini" @click="Aduit(1)" icon="el-icon-success" :disabled="!btn.btn6">{{$t('getapi[4643]')}}
					</el-button>
					<el-button type="primary" size="mini" @click="Aduit(2)" icon="el-icon-error" :disabled="!btn.btn7">{{$t('getapi[1334]')}}
					</el-button>
				</div>
				<div>
					<table>
						<tr>
							<td style="width:80px;min-width: 80px"><span>{{$t('getapi[3102]')}}</span></td>
							<td style="width:120px;min-width: 120px">
								<el-input  size="mini" v-model="dataDetail.Order_No" :readonly="true" class="readO"></el-input>
							</td>
							<td style="width:80px;min-width: 80px"><span>{{$t('getapi[1861]')}}</span></td>
							<td style="width:120px;min-width: 120px">
								<el-input v-if="dataDetail.Order_Status == 0" :value="$t('getapi[1422]')" size="mini" :readonly="true" class="readO"></el-input>
								<el-input v-if="dataDetail.Order_Status == 1" :value="$t('getapi[3607]')" size="mini" :readonly="true" class="readO"></el-input>
							</td>
							<td style="width:80px;min-width: 80px"><span>{{$t('getapi[7653]')}}</span></td>
							<td style="width:120px;min-width: 120px">
								<el-input v-if="dataDetail.Finance_Status == 2" :value="$t('getapi[3754]')" size="mini" :readonly="true" class="readO"></el-input>
								<el-input v-if="dataDetail.Finance_Status != 2" value="" size="mini" :readonly="true" class="readO"></el-input>
							</td>
							<td style="width:80px;min-width: 80px"><span>{{$t('getapi[7650]')}}</span></td>
							<td style="width:120px;min-width: 120px">
								<el-select filterable v-model="dataDetail.Just_Year" :disabled="isDateEdit" style="width: 100%;">
									<el-option v-for="(item, index) in yearList" :label="item.label" :value="item.value" :key="index"></el-option>
								</el-select>
							</td>
						</tr>
						<tr>
							<td><span>{{$t('getapi[1890]')}}</span></td>
							<td><el-input  size="mini" v-model="dataDetail.Create_Person" :readonly="true" class="readO"></el-input></td>
							<td><span>{{$t('getapi[733]')}}</span></td>
							<td><el-input  size="mini" v-model="dataDetail.Modify_Person" :readonly="true" class="readO"></el-input></td>
							<td><span>{{$t('getapi[4043]')}}</span></td>
							<td><el-input  size="mini" v-model="dataDetail.Audit_Person" :readonly="true" class="readO"></el-input></td>
							<td><span>{{$t('getapi[7651]')}}</span></td>
							<td>
								<el-select filterable v-model="dataDetail.Just_Month" :disabled="isDateEdit" style="width: 100%;">
									<el-option v-for="(item, index) in monthList" :label="item.label" :value="item.value" :key="index"></el-option>
								</el-select>
							</td>
						</tr>
						<tr>
							<td><span>{{$t('getapi[1859]')}}</span></td>
							<td><el-input  size="mini" v-model="dataDetail.Create_Date" :readonly="true" class="readO"></el-input></td>
							<td><span>{{$t('getapi[734]')}}</span></td>
							<td><el-input  size="mini" v-model="dataDetail.Modify_Time" :readonly="true" class="readO"></el-input></td>
							<td><span>{{$t('getapi[742]')}}</span></td>
							<td><el-input  size="mini" v-model="dataDetail.Audit_Date" :readonly="true" class="readO"></el-input></td>
							<td><span>{{$t('getapi[143]')}}</span></td>
							<td><el-input  size="mini" v-model="dataDetail.Remark"></el-input></td>
						</tr>
						<tr>
							<td><span>{{$t('getapi[7658]')}}</span></td>
							<td><el-input type="number" @mousewheel.native.prevent size="mini" v-model="totalDetail.txtMaterialTotal" :readonly="true" class="readO"></el-input></td>
							<td><span>{{$t('getapi[7659]')}}</span></td>
							<td><el-input type="number" @mousewheel.native.prevent size="mini" v-model="totalDetail.txtManTotal" :readonly="true" class="readO"></el-input></td>
							<td><span>{{$t('getapi[7660]')}}</span></td>
							<td><el-input type="number" @mousewheel.native.prevent size="mini" v-model="totalDetail.txtChargeTotal" :readonly="true" class="readO"></el-input></td>
							<td><span>{{$t('getapi[7661]')}}</span></td>
							<td><el-input type="number" @mousewheel.native.prevent size="mini" v-model="totalDetail.txtTotal" :readonly="true" class="readO"></el-input></td>
						</tr>
					</table>
				</div>
				<!--<div class="box" style="margin-top:5px">
				<div class="bbl" style="margin-top:5px">
				<span>{{$t('getapi[3102]')}}</span>
				<el-input  size="mini" style="width: 130px;" v-model="dataDetail.Order_No" :readonly="true" class="readO"></el-input>
				<span>{{$t('getapi[1861]')}}</span>
				&lt;!&ndash; <el-input type="number" size="mini" style="width: 120px;" v-model="dataDetail.Order_Status" disabled> &ndash;&gt;
                <el-input v-if="dataDetail.Order_Status == 0" :value="$t('getapi[1422]')"  style="width: 130px" size="mini" :readonly="true" class="readO"></el-input>
                <el-input v-if="dataDetail.Order_Status == 1" :value="$t('getapi[3607]')"  style="width: 130px" size="mini" :readonly="true" class="readO"></el-input>

				<span>{{$t('getapi[7653]')}}</span>
				&lt;!&ndash; <el-input  size="mini" style="width: 120px;" v-model="dataDetail.Finance_Status" disabled></el-input> &ndash;&gt;
                <el-input v-if="dataDetail.Finance_Status == 2" :value="$t('getapi[3754]')"  style="width: 130px" size="mini" :readonly="true" class="readO"></el-input>
                <el-input v-if="dataDetail.Finance_Status != 2" value=""  style="width: 130px" size="mini" :readonly="true" class="readO"></el-input>

				<span>{{$t('getapi[7650]')}}</span>
				&lt;!&ndash;<el-input type="number" size="mini" style="width: 130px;" v-model="dataDetail.Just_Year" disabled></el-input>&ndash;&gt;
				<el-select filterable v-model="dataDetail.Just_Year" :disabled="isDateEdit" style="width: 130px;">
					<el-option v-for="(item, index) in yearList" :label="item.label" :value="item.value" :key="index"></el-option>
				</el-select>
				</div>
				<div class="bbl">
				<span>{{$t('getapi[1890]')}}</span>
				<el-input  size="mini" style="width: 130px;" v-model="dataDetail.Create_Person" :readonly="true" class="readO"></el-input>
				<span>{{$t('getapi[733]')}}</span>
				<el-input  size="mini" style="width: 130px;" v-model="dataDetail.Modify_Person" :readonly="true" class="readO"></el-input>
				<span>{{$t('getapi[4043]')}}</span>
				<el-input  size="mini" style="width: 130px;" v-model="dataDetail.Audit_Person" :readonly="true" class="readO"></el-input>
				<span>{{$t('getapi[7651]')}}</span>
				&lt;!&ndash;<el-input  type="number" size="mini" style="width: 130px;" v-model="dataDetail.Just_Month" disabled></el-input>&ndash;&gt;
				<el-select filterable v-model="dataDetail.Just_Month" :disabled="isDateEdit" style="width: 130px;">
					&lt;!&ndash;<el-option label="请选择" value="0"></el-option>&ndash;&gt;
					<el-option v-for="(item, index) in monthList" :label="item.label" :value="item.value" :key="index"></el-option>
				</el-select>
				</div>
				<div class="bbl">
				<span>{{$t('getapi[1859]')}}</span>
				<el-input  size="mini" style="width: 130px;" v-model="dataDetail.Create_Date" :readonly="true" class="readO"></el-input>
				<span>{{$t('getapi[734]')}}</span>
				<el-input  size="mini" style="width: 130px;" v-model="dataDetail.Modify_Time" :readonly="true" class="readO"></el-input>
				<span>{{$t('getapi[742]')}}</span>
				<el-input  size="mini" style="width: 130px;" v-model="dataDetail.Audit_Date" :readonly="true" class="readO"></el-input>
                <span>{{$t('getapi[143]')}}</span>
				<el-input  size="mini" style="width: 130px;" v-model="dataDetail.Remark"></el-input>

				</div>
				<div class="bbl">
				<span>{{$t('getapi[7658]')}}</span>
				<el-input type="number" @mousewheel.native.prevent size="mini" style="width: 130px;" v-model="totalDetail.txtMaterialTotal" :readonly="true" class="readO"></el-input>
				<span>{{$t('getapi[7659]')}}</span>
				<el-input type="number" @mousewheel.native.prevent size="mini" style="width: 130px;" v-model="totalDetail.txtManTotal" :readonly="true" class="readO"></el-input>
				<span>{{$t('getapi[7660]')}}</span>
				<el-input type="number" @mousewheel.native.prevent size="mini" style="width: 130px;" v-model="totalDetail.txtChargeTotal" :readonly="true" class="readO"></el-input>
				<span>{{$t('getapi[7661]')}}</span>
				<el-input type="number" @mousewheel.native.prevent size="mini" style="width: 130px;" v-model="totalDetail.txtTotal" :readonly="true" class="readO"></el-input>
				</div>
				</div>-->
				<div style="display: flex">
					<el-button type="primary" size="mini" @click="addline()" icon="el-icon-circle-plus" :disabled="!btn.btn0">{{$t('getapi[878]')}}
					</el-button>
					<el-button type="primary" size="mini" @click="delline()" icon="el-icon-delete-solid" :disabled="!btn.btn1">{{$t('getapi[7662]')}}
					</el-button>
					<el-button type="primary" size="mini" @click="dellineAll()" :disabled="!btn.btn2">{{$t('getapi[7663]')}}
					</el-button>
					<!--<el-button type="primary" size="mini" @click="getRemark()" :disabled="!btn.btn3">编辑单据备注
					</el-button>
					<el-button type="primary" size="mini" @click="OpenOrCloseRemark()" :disabled="!btn.btn4">{{RemarkBtn}}
					</el-button>-->
					<el-button type="primary" size="mini" @click="downFile()" :disabled="!btn.btn5">{{$t('getapi[2348]')}}
					</el-button>
					<el-upload
							class="upload-demo"
							ref="upload"
							:action="uploadurl"
							:on-preview="handlePreview"
							:on-remove="handleRemove"
							:on-change="handleChange"
							:on-success="handleSuccess"
							:on-error="handleError"
							:file-list="fileList"
							:limit="1"
							:disabled="isimport"
					>
						<el-button type="primary" :disabled="isimport"  style="margin-left:10px" size="mini">{{$t('getapi[6119]')}}<i class="el-icon-upload el-icon--right"></i>
						</el-button>
					</el-upload>
				</div>
				<el-table
				id="xdetilpane-0"
				:data="dataDetail.CostJustOrderLine"
				ref="singleTable1"
				v-loading="dloading"
				:highlight-current-row="true"
				show-overflow-tooltip="true"
				border
				stripe
				size="mini"
				:row-class-name="tableRowClassName"
				@selection-change="handleSelectionChange"
				:height="tableHeight - 160"
				header-row-class-name="headerclass"
				style="width: 100%; margin-top:3px"
				>
				<el-table-column type="selection" v-if="dataDetail.Order_Status == 0"></el-table-column>
				
				<!-- <el-table-column show-overflow-tooltip prop="Line_no" :label="$t('getapi[1297]')" width="50"></el-table-column>
				<el-table-column show-overflow-tooltip prop="Part_code" :label="$t('getapi[226]')" width="150">
				<template slot-scope="scope" >
				<el-input v-if="IsEdit" class="mcolor"  v-model="scope.row.Part_code">
				<i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectpart(scope)"></i>
				</el-input>
				<span v-if="!IsEdit">{{scope.row.Part_code}} </span>
				</template>

				</el-table-column> -->
				
				<el-table-column show-overflow-tooltip prop="Line_No" :label="$t('getapi[1425]')"></el-table-column>
				<el-table-column show-overflow-tooltip prop="Part_code" :label="$t('getapi[112]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"></el-table-column>
				<el-table-column show-overflow-tooltip prop="Part_version" :label="$t('getapi[149]')"></el-table-column>
                <el-table-column show-footer-overflow prop="part_model" :label="$t('getapi[124]')"></el-table-column>
                <el-table-column show-footer-overflow prop="part_spec" :label="$t('getapi[125]')"></el-table-column>
                <el-table-column show-footer-overflow prop="part_stuff" :label="$t('getapi[126]')"></el-table-column>  
				<el-table-column show-overflow-tooltip prop="Category_First_Name" :label="$t('getapi[169]')"></el-table-column>
				<el-table-column show-overflow-tooltip prop="Category_Second_Name" :label="$t('getapi[170]')"></el-table-column>
				<el-table-column show-overflow-tooltip prop="Category_Third_Name" :label="$t('getapi[171]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="Init_Qty" :label="$t('getapi[7299]')" align="right"></el-table-column>
				<el-table-column show-overflow-tooltip prop="unit_price" :label="$t('getapi[1410]')" align="right"></el-table-column>
				<el-table-column show-overflow-tooltip prop="Receive_Qty" :label="$t('getapi[1850]')" align="right"></el-table-column>
				<el-table-column show-overflow-tooltip prop="Receive_Material_Cost" :label="$t('getapi[7655]')" align="right" width="100px"></el-table-column>
				<el-table-column show-overflow-tooltip prop="Receive_Man_Cost" :label="$t('getapi[7656]')" align="right"  width="100px"></el-table-column>
				<el-table-column show-overflow-tooltip prop="Receive_Charge_Cost" :label="$t('getapi[7657]')" align="right"  width="100px"></el-table-column>
				<el-table-column prop="Receive_Adjust_Material_Cost" :label="$t('getapi[5133]')" align="right"  width="120px">
                <template slot-scope="scope" >
                <el-input v-if="IsEdit" type='number' v-model="scope.row.Receive_Adjust_Material_Cost"></el-input>
                <span v-if="!IsEdit">{{scope.row.Receive_Adjust_Material_Cost}} </span>
                </template>
                </el-table-column>
				<el-table-column prop="Receive_Adjust_Man_Cost" :label="$t('getapi[5134]')" align="right"  width="100px">
                <template slot-scope="scope" >
                <el-input v-if="IsEdit" type='number' v-model="scope.row.Receive_Adjust_Man_Cost"></el-input>
                <span v-if="!IsEdit">{{scope.row.Receive_Adjust_Man_Cost}} </span>
                </template>
                </el-table-column>
				<el-table-column prop="Receive_Adjust_Charge_Cost" :label="$t('getapi[5135]')" align="right"  width="100px">
                <template slot-scope="scope" >
                <el-input v-if="IsEdit" type='number' v-model="scope.row.Receive_Adjust_Charge_Cost"></el-input>
                <span v-if="!IsEdit">{{scope.row.Receive_Adjust_Charge_Cost}} </span>
                </template>
                </el-table-column>
				<el-table-column prop="Line_Remark" :label="$t('getapi[143]')" width="350px">
                <template slot-scope="scope" >
                <el-input v-if="IsEdit" type='txt' v-model="scope.row.Line_Remark"></el-input>
                <span v-if="!IsEdit">{{scope.row.Line_Remark}} </span>
                </template>
                </el-table-column>

				</el-table>

				
            </li>
        </ul>
        <el-row class="page">
				<el-col :span="18">
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-sizes="[100, 200, 300, 400]"
						:page-size="pageSize"
						:pager-count="5"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total"
					></el-pagination>
				</el-col>
				<el-col :span="6">
					<div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
				</el-col>
			</el-row>
        

        <serce :isVisible="isVisible" queryData="RecCostViewInfo" ref="ser" @getser="serclick"></serce>
		<ctable :isVisible="false" :title="$t('getapi[6653]')" queryData="RecCostViewInfo" tabNo="0" ref="ctab"
				@getctab="sortclick"></ctable>
        <!-- 选择物料弹框 -->
        <selector :isVisible="false" :isBatch=true :selectType="14" :isSplitPage=true :postUrl="'/Basic/Popup/GetPartPopuDataList'" @callback="getpart" ref="part"></selector>
        <el-dialog v-dialogDrag :title="$t('getapi[7664]')" :visible.sync="dialogVisible" width="30%">
			<div class="bbl">
            <el-input type="textarea" size="mini" style="width: 500px;" :autosize="{ minRows: 8}"
                                      v-model="remarkValue"></el-input>


			</div>
			<span slot="footer" class="dialog-footer">
				<el-button  @click="dialogVisible = false">{{$t('getapi[6]')}}</el-button>
				<el-button type="primary" @click="saveRemark()">{{$t('getapi[1146]')}}</el-button>
			</span>
		</el-dialog>

        <el-dialog v-dialogDrag :visible.sync="isShowSelectSheet" width="25%" :close-on-click-modal="false">
            <el-table
                    :data="dataSelectSheet"
                    ref="sheetTable"
                    :highlight-current-row="true"
                    show-overflow-tooltip="true"
                    border
                    size="mini"
                    @row-click="changeItem_codeM"
                    @selection-change="handleSelectionChangeM"
                    header-row-class-name="headerclass"
                    style="width: 100%; margin-top:0px"
            >
                <el-table-column type="selection"></el-table-column>
                <el-table-column show-overflow-tooltip prop="name" :label="$t('getapi[6388]')"></el-table-column>
            </el-table>

            <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="isShowSelectSheet = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button size="mini" type="primary" @click="getNoBalanceData" :disabled="selectNameData.length != 1">{{ $t('getapi[1146]') }}</el-button>
			</span>
        </el-dialog>
        

    </div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
import CommonHeader from '@/components/CommonHeader';

    export default {
        name: '3_reccostmanage',
        data() {
            return {
                tableOption: {
                    border: true,
                    height: Common.tableHeight3, // 主表高度ss
                    maxHeight: Common.tableHeight3 // 主表高度
                },
                tableHeader: [],
				viewurl:'/CostCalc/CostJustView/GetRecCostJustOrderView',
				expurl:'/CostCalc/CostJustView/GetRecCostJustOrderViewToExecl',
				detailurl:'/CostCalc/CostJustView/CostJustOrderRecManageExInfo',
                IsEditCode:false,
                IsDetailRemarkView:false,
                dialogVisible:false,
                RemarkBtn:'显示明细备注',
                remarkValue:'',
                visReplacePart:false,
                isVisible: false, // 查询列表是否显示
                uploadurl:'',
                fileList:[],
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                dataSet: [], // 主表数据
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('3_reccostmanage'), // 当前页数据量
                total: 0, // 数据总量
                SelectIndex: 0, //当前页面
                dataSet1: [], // 主表数据
                pageIndex1: 1, // 当前页
                pageSize1: 100, // 当前页数据量
                total1: 0, // 数据总量
                dataSet2: [], // 主表数据
                pageIndex2: 1, // 当前页
                pageSize2: 100, // 当前页数据量
                total2: 0, // 数据总量
                dataSet3: [], // 主表数据
                pageIndex3: 1, // 当前页
                pageSize3: 100, // 当前页数据量
                total3: 0, // 数据总量
                dataSet4: [], // 主表数据
                pageIndex4: 1, // 当前页
                pageSize4: 100, // 当前页数据量
                total4: 0, // 数据总量

                dataSet5: [], // 主表数据
                pageIndex5: 1, // 当前页
                pageSize5: 100, // 当前页数据量
                total5: 0, // 数据总量


                loading: false, // 主表加载状态
                dloading:false,//此表加载状态
                IsEditPrice:false,//是否可以编辑不含税单价
                RStartName:'',//前端缓存外协工序名
                tableHeight: Common.tableHeight3, // 主表高度
                dataDetail:{},
                totalDetail:{
                txtMaterialTotal:"0",
                txtManTotal:"0",
                txtChargeTotal:"0",
                txtTotal:"0"
                },//总额明细
                oldDataDetail:'',
                SignList: [],
                TransList:[],//运输方式
                multipleSelection: [],//左侧主表选择
                multipleSelectionMain: [],
                selectData1: [],
                selectData2: [],
                selectData3: [],
                selectData4: [],
                Line_No:0,
                partindex:0,
                personindex:0,
                IsEdit : true,
                btn:{
                    btn0:false,
                    btn1:false,
                    btn2:false,
                    btn3:false,
                    btn4:false,
                    btn5:false,
                    btn6:false,
                    btn7:false,
                },
                srType: [],//sr类别
                orderDetail: {
                    plancode: '',
                    issrso: '0',
                    isnewflag: '0',
                    sotype: '0',
                    flag: 1,
                    issselfbadflag: '0',
                    iscontinue: 0,
                },
                visOrder: false,
                otherobj:[],//来源跳转页面
                paramobj:[{}],
                orderType: 1,
                orderAPrice:0,//订单税额
                orderBPrice:0,//订单不含税额
                orderCPrice:0,//订单含税额  A+B=C
                DeptList:[],

                isShowSelectSheet: false, // 是否显示选择sheet弹窗
                dataSelectSheet: [], //
                selectNameData: [], // 选择的sheet
                selectIndex: '', //选中行下标
                RightSelectIndex: 0, //右侧明细当前页面
                yearList:[],
                monthList: [
                    {
                        value: 1,
                        label:1
                    },
                    {
                        value: 2,
                        label:2
                    },
                    {
                        value: 3,
                        label:3
                    },
                    {
                        value: 4,
                        label:4
                    },
                    {
                        value: 5,
                        label:5
                    },
                    {
                        value: 6,
                        label:6
                    },
                    {
                        value: 7,
                        label:7
                    },
                    {
                        value: 8,
                        label:8
                    },
                    {
                        value: 9,
                        label:9
                    },
                    {
                        value: 10,
                        label:10
                    },{
                        value: 11,
                        label:11
                    },
                    {
                        value: 12,
                        label:12
                    }
                ],
                isDateEdit: true,
				code: '',
                oldrow: '',
                iscontinuedblclick: true,
                isimport:true,
                isimportsave:0,
                scrollTop:0,
                scrollTop1:0,
            };
        },
        beforeMount() {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            let token = JSON.parse(that.userData).token;
            that.uploadurl = Common.Url + '/Fin/Wip/BalanceLockImportUpFile?token=' + token;
        },
        mounted: function () {
            let that = this;
            that.colsort();
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username;
            //that.dataDetail.Trans_Type
            that.$limits.dragControllerDiv();
            let thisyear = new Date().getFullYear();
            for(let i=0;i<10;i++){
                let obj = {
                    value: thisyear-i,
                    label:thisyear-i
                };
                that.yearList.push(obj);
            }
            that.$nextTick(function () {
                that.$processdata.initForm()
                that.$processdata.initFormRight()
            })
            that.confirmAdd()
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop1;
                }, 13)
            })
        },
        methods: {
            colsort(){
                let that = this;
                that.$loadviewfields.Fileds('RecCostViewInfo',0,PFileds=>{
                    that.tableHeader=PFileds;
                });
            },
            sortclick(val){
                if(val==1){
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable(){
                this.$refs.ctab.clearInputs(true);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6653]"),this.$t("getapi[6633]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                if (!that.$limits.fnIsEmpty(that.dataDetail.Order_No)){
                    if(that.dataDetail.Order_Status==0){
                        that.isimport=false;
                    }
                    else{
                        that.isimport=true;
                    }
                }
                else{
                    that.isimport=true;
                }

                //管理界面
                if (that.$limits.authority('plv2', 433, 1) == 1) {
                    //只读权
                    that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                }
                if (that.$limits.authority('plv2', 433, 1) == 2) {
                    if (that.$limits.authority('plv3', 433,1) == 0) {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }

                    //操作权
                    if (that.$limits.authority('plv3', 433,1) == 1) {
                        //编辑级
                        if (that.$limits.fnIsEmpty(that.dataDetail.Order_No))
                        {
                            that.$refs.SetBtn.SetButtonEnable('create,search,save,refresh,export');
                        }
                        else
                        {
                            if(that.dataDetail.Order_Status>0){
                                that.$refs.SetBtn.SetButtonEnable('create,search,refresh,export');
                            }else{
                                that.$refs.SetBtn.SetButtonEnable('create,search,save,refresh,export');
                            }
                            

                        }
                    }
                    if (that.$limits.authority('plv3', 433, 1) == 2) {
                        //删除级

                        if (that.$limits.fnIsEmpty(that.dataDetail.Order_No))
                        {
                        that.$refs.SetBtn.SetButtonEnable('create,search,save,refresh,export');
                        }
                        else
                        {
                            if(that.dataDetail.Order_Status>0){
                                that.$refs.SetBtn.SetButtonEnable('create,search,refresh,export');
                            }else{
                                that.$refs.SetBtn.SetButtonEnable('create,search,save,del,refresh,export');
                            }
                        }
                    }
                }
                
                that.btnauthority();
            },
            btnauthority() {
                let that = this;
                that.btn.btn0   = false;
                that.btn.btn1   = false;
				that.btn.btn2   = false;
                that.btn.btn3   = true;
                that.btn.btn4   = true;
                that.btn.btn5   = false;
                that.btn.btn6   = false;
                that.btn.btn7   = false;
				// 0生成   1 审核
				if(that.dataDetail.Order_Status == 0){
				that.btn.btn0   = true;
                that.btn.btn1   = true;
				that.btn.btn2   = true;
                //that.btn.btn3   = true;
                //that.btn.btn4   = true;
                that.btn.btn5   = true;
                if(!that.$limits.fnIsEmpty(that.dataDetail.Order_No))that.btn.btn6   = true;

				}else{
                    //反审 按钮开出
                   if(!that.$limits.fnIsEmpty(that.dataDetail.Order_No)) that.btn.btn7   = true;
                }

            },
			getMonth(IsNew) {
			let that = this;
			that.$http.urlpost('/CostCalc/CostJustView/GetLastEndCostYearMonth', {}, function(res) {
			if (res.Success == 1) {
			if(res.DataContent!=null)
			{
				that.isDateEdit = true;
				that.dataDetail.Just_Year = res.DataContent.TYear;
				that.dataDetail.Just_Month = res.DataContent.Month;
				console.log(res.DataContent.TYear)
				//11111111111111111111
			}else{//开启编辑
				that.isDateEdit = false
			}
			if(IsNew){
				that.oldDataDetail = JSON.stringify(that.dataDetail);
			}	
			}
			});
			},
            getRemark(){
            let that = this;
            that.dialogVisible = true;
            that.remarkValue='';
            let param = {
                OrderNo:that.dataDetail.Order_No
            }
            that.$http.urlpost('/CostCalc/CostJustView/GetOrderRemark', param, function(res) {
            if (res.Success == 1) {
               that.remarkValue = that.$processdata.explainCallbackMsg(res.Msg)
            }
            });          
            },
            saveRemark(){
            let that = this;
            let param = {
            ReMark:that.remarkValue,
            OrderNo: that.dataDetail.Order_No
            }
            that.$http.urlpost('/CostCalc/CostJustView/SaveOrderRemark', param, function(res) {
            if (res.Success == 1) {
            that.$message.success(that.$t('getapi[8628]'));//'更新成功！'
            that.dialogVisible = false;
            }
            });
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                if(!that.iscontinuedblclick){
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('3_reccostmanage',val)
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
            },

            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log("handlePreview"+file);
            },
            handleChange(file, fileList) {
                let that = this;
                that.loading = true;
                console.log(file);
                if (file.response) {
                    let response = file.response.Success;
                    if (response == 0) {
                        that.$message.error(file.response.Msg);
                    }
                    that.loading = false;
                }
            },
            handleSuccess(res, file, fileList) {
                let that = this;
                console.log(res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg))
                } else {
                    that.returnURL = res.DataContent.URL;
                    let arr = res.DataContent.SheetList
                    if(arr.length > 0){
                        that.dataSelectSheet = []
                        for(let i=0;i<arr.length;i++){
                            that.dataSelectSheet = [...that.dataSelectSheet,{
                                name: arr[i]
                            }]
                        }
                        that.isShowSelectSheet = true
                    }
                }
                that.fileList=[];
                that.loading = false;
            },
            handleError(err, file, fileList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
                that.loading = false;
            },
            changeItem_codeM(row) {
                let that = this
                that.$refs.sheetTable.toggleRowSelection(row);
            },
            // 批量选择
            handleSelectionChangeM(val) {
                let that = this
                console.log(val)
                that.selectNameData = []
                for(let i = 0;i<val.length;i++){
                    that.selectNameData.push(val[i].name)
                }
            },
            getNoBalanceData(){
                let that = this
                let parm = {
                    filepath: that.returnURL,
                    sheetname: that.selectNameData[0],
                    costyear: that.dataDetail.Just_Year,
                    costmonth: that.dataDetail.Just_Month,
                    modify_time:that.dataDetail.Modify_Time,
                    order_no:that.dataDetail.Order_No,
                    LangType:that.$processdata.getLang(),
                }
                
                that.$http.urlpost('/CostCalc/CostJustView/GetCostJustOrderRecManageData', parm, function (res) {
                    if (res.Success == 1) {
                        that.Line_No = 1;
                        for (let i = 0; i < that.dataDetail.CostJustOrderLine.length; i++) {
                            if (that.dataDetail.CostJustOrderLine[i].Line_No >= that.Line_No) {
                                that.Line_No= that.dataDetail.CostJustOrderLine[i].Line_No + 1;
                            }
                        }
                        for(let i=0;i<res.DataContent.Lists.length;i++){
                            
                            let Relation_IID_Temp=0;
                            if(!that.$limits.fnIsEmpty(that.dataDetail.Order_No)){
                                Relation_IID_Temp = that.dataDetail.Order_No;
                            }
                            let deti = {
                                IsNew:1,
                                Relation_Order_No:Relation_IID_Temp.toString(),
                                Line_No: that.Line_No++,
                                Part_code:res.DataContent.Lists[i].part_code,
                                Part_version:res.DataContent.Lists[i].part_version,
                                Category_First_Name:"",
                                Category_Second_Name:"",
                                Category_Third_Name:"",
                                Init_Qty:0,
                                unit_price:0,
                                Receive_Qty:0,
                                Receive_Material_Cost:0,
                                Receive_Man_Cost:0,
                                Receive_Charge_Cost:0,
                                Receive_Adjust_Material_Cost:res.DataContent.Lists[i].receive_adjust_material_cost,
                                Receive_Adjust_Man_Cost:res.DataContent.Lists[i].receive_adjust_man_cost,
                                Receive_Adjust_Charge_Cost:res.DataContent.Lists[i].receive_adjust_charge_cost,
                                Line_Remark:res.DataContent.Lists[i].line_remark,
                            };
                            that.dataDetail.CostJustOrderLine.push(deti);
                        }
                        // that.datajson = res.DataContent
                        that.isShowSelectSheet = false
                        that.btn.canDoCloseWIP = false
                        that.isimportsave=1;
                        console.log("1isimportsave"+that.isimportsave)
                        that.save();

                    }
                    else{
                        that.isimportsave=0;
                        that.isShowSelectSheet = false
                        that.btn.canDoCloseWIP = false
                    }
                });
            },
			
            selectInfo(tab, event) {
                let that = this;
                that.SelectIndex = tab.name;
                that.getView();
            },
            selectemployee(row) {
                let that = this;
                that.personindex = row.$index;
                that.$refs.employee.clearInput(true);
                
            },
            getemployee(data){
                let that = this;
                console.log(data)
                that.dataDetail.CostJustOrderLine[that.personindex].Response_person = data.name;           
            },
            OpenOrCloseRemark(){
                let that = this;
                if(that.IsDetailRemarkView){
                    that.RemarkBtn='显示明细备注';
                    that.IsDetailRemarkView = false;
                }else{
                    that.RemarkBtn='隐藏明细备注';
                    that.IsDetailRemarkView = true;
                }
                
            },
			//更新标准成本
            updatecost(){
                let that = this;
                let parm={ }
                that.btn.updatecost = false;
                that.$http.urlpost('/Inv/PartCost/InvPartStdCostUpdate', parm, function (res) {
                if (res.Success == 1) {
                that.$message.success(that.$t('getapi[8628]'));//'更新成功！'
                //that.getDetail(that.dataDetail.Order_No)
                }
                });

            },
			Aduit(val){
				let that = this;
                let parm={
                    TYear: that.dataDetail.Just_Year,
                    Month: that.dataDetail.Just_Month,
                    Flag: val,
                    OrderNo: that.dataDetail.Order_No,
                    Modify_Time:that.dataDetail.Modify_Time
                }
                that.btn.audit = false;
                that.btn.btn6 = false
                that.btn.btn7 = false
                that.$http.urlpost('/CostCalc/CostJustView/SetStatus', parm, function (res) {
                if (res.Success == 1) {
                that.$message.success(that.$t('getapi[8782]'));//'操作成功'
                that.getDetail(that.dataDetail.Order_No)
                }
                    that.btn.btn6 = true
                    that.btn.btn7 = true
                });

			},
			addline() {
			let that = this;
			let parm = {
			PUBPart_ID: "",
			costYear: that.dataDetail.Just_Year,
			costMonth: that.dataDetail.Just_Month
			};
			that.$refs.part.clearInput(true,parm);
			},
            downFile(){
            let that = this;
            let param = {
				TYear: that.dataDetail.Just_Year,
				Month: that.dataDetail.Just_Month,
            }
            that.$http.urlpost('/CostCalc/CostJustView/GetBlankImportTemplate', param, function (res) {
				if (res.Success == 1) {
					let hrefurl = Common.Url + res.DataContent.URL;
					window.open(hrefurl);
				}
            });
            },
            //取消下达
            CancelDownOrder(){
                let that = this;

                let parm={
                code: that.dataDetail.Exclusively_ID,
                ids: "",
                update_time:  that.dataDetail.Modify_Date,
					LangType: that.$processdata.getLang()
                }
                that.btn.cancelassign = false;
                that.$http.urlpost('/ISS/Order/UnExeAudit', parm, function (res) {
                if (res.Success == 1) {
                that.$message.success(that.$t('getapi[8631]'));//'取消下达成功！'
                that.getDetail(that.dataDetail.Exclusively_ID)
                }
                });

            },
            //确认关闭
            CloseOrder(){
                let that = this;
                this.$confirm(that.$t('getapi[8629]'), that.$t('getapi[194]'), {//'你确认要关闭吗?'
                confirmButtonText: that.$t('getapi[1146]'),
                cancelButtonText: that.$t('getapi[2054]'),
                type: 'warning'
                }).then(() => {

                    if(that.$limits.fnIsEmpty(that.dataDetail.Shut_reason)){
                        that.$message.warning(that.$t('getapi[8630]'));//请填写强制关闭原因
                        return;
                    }
                    let parm={
                    code: that.dataDetail.Exclusively_ID,
                    ids: "",
                    update_time:  that.dataDetail.Modify_Date,
						LangType: that.$processdata.getLang()
                    }
                    that.btn.confirmclose = false;
                    that.$http.urlpost('/ISS/Order/OkClose', parm, function (res) {
                    if (res.Success == 1) {
                    that.$message.success(that.$t('getapi[4230]'));//关闭成功
                    that.getDetail(that.dataDetail.Exclusively_ID)
                    }
                    });
                }).catch(() => {
                // this.$message({
                // type: 'info',
                // message: '已取消删除'
                // });   
                });


                

            },
            //批量设为无效
            setInvalid(){
                let that = this;
                let parm={
                    Code:'',
                };
                for(let i=0;i<that.multipleSelection.length;i++){
                    parm.Code+=that.multipleSelection[i].num+',';

                }
                parm.Code =  parm.Code.substring(0, parm.Code.length - 1);
                that.$http.urlpost('/ISS/PQ/UnISSPQ', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$t('getapi[321]'));//'设置成功！'
                        that.getView();
                        that.getDetail(that.dataDetail.num);//刷右边
                    }
                });
            },
            setClose(){

            },
            setAssign(e) {
                let that = this;
                if(that.$limits.fnIsEmpty(that.dataDetail.Exclusively_ID)){
                    return;
                }

            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'RecCostViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                //当前是哪个页面就把哪个置为1
                if (this.SelectIndex == 0) {
                this.pageIndex = 1;
                } else if (this.SelectIndex == 1) {
                this.pageIndex1 = 1;
                } else if (this.SelectIndex == 2) {
                this.pageIndex2 = 1;
                } 
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },

            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndex,
                    Param: datac
                };
                that.$http.urlpost(that.viewurl, data, function (res) {
                    if (res.Success == 1) {
                        if (that.SelectIndex == 0) {
                            that.dataSet = res.DataContent;
                            that.total = res.Totals;
                        }
                        that.$nextTick(function(){
                            that.$processdata.initForm(this.SelectIndex)
                        });
                        that.DbTbNames = res.DbTbNames;
                    }
                    that.loading = false;
                });
            },
            // 根据ID获取详情数据
            leftClick(row) {
                let that = this
                if (that.code == row.order_no) {
                    return
                }
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.CostJustOrderLine.length;i++){
                    delete datacopy.CostJustOrderLine[i]['index']
                }
                if(that.oldDataDetail != JSON.stringify(datacopy)){
                    that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        closeOnClickModal: false,
                        type: 'warning'
                    })
                        .then(() => {
                            that.iscontinuedblclick = true
                            that.oldrow = row
                            that.code = row.order_no
                            that.getDetail(row.order_no)
                        })
                        .catch(() => {
                            that.iscontinuedblclick = false
							that.$refs.singleTable.setCurrentRow(that.oldrow);
                        });
                } else {
                    that.iscontinuedblclick = true
                    that.oldrow = row
                    that.code = row.order_no
                    that.getDetail(row.order_no)
                }
            },
            // 新增
            add() {
                let that = this;
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.CostJustOrderLine.length;i++){
                    delete datacopy.CostJustOrderLine[i]['index']
                }
                if(that.oldDataDetail != JSON.stringify(datacopy)){
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd()
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd()
                }
            },
			confirmAdd(){
			let that = this;
			let date = Common.methods.getDate()
			that.code = ''
			that.dataDetail = {
			newFlag: 0,
			Order_No: "",
			Order_Type_Code: "",
			Create_Person: that.user,
			Create_Date: "",
			Modify_Person: "",
			Modify_Time: "",
			Audit_Person: "",
			Audit_Date: "",
			Order_Status: 0,
			Finance_Status: -1,
			Remark: "",
			Just_Year: '',
			Just_Month: '',
			CostJustOrderLine: [],
			CostJustOrderLineIssue: []
			}
			that.getMonth(true);
			that.totalDetail.txtMaterialTotal="0",
            that.totalDetail.txtManTotal="0",
            that.totalDetail.txtChargeTotal="0",
            that.totalDetail.txtTotal="0"
			that.authority();
			},
            // 刷新
            reflash() {
                /*let that = this;
                that.getView();
                if(!that.$limits.fnIsEmpty(that.dataDetail.Exclusively_ID)){
                    that.IsEditCode = false;
                    that.dataDetail.IsEdit = 1;
                    that.getDetail(that.dataDetail.Exclusively_ID);
                }*/
                let that = this;
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.CostJustOrderLine.length;i++){
                    delete datacopy.CostJustOrderLine[i]['index']
                }
                if(that.oldDataDetail != JSON.stringify(datacopy)){
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.getView();
                            if(!that.$limits.fnIsEmpty(that.dataDetail.Order_No)){
                                that.IsEditCode = false;
                                //that.dataDetail.IsEdit = 1;
                                that.getDetail(that.dataDetail.Order_No);
                            } else {
                                that.confirmAdd()
                            }
                        });
                } else {
                    that.getView();
                    if(!that.$limits.fnIsEmpty(that.dataDetail.Order_No)){
                        that.IsEditCode = false;
                        //that.dataDetail.IsEdit = 1;
                        that.getDetail(that.dataDetail.Order_No);
                    } else {
                        that.confirmAdd()
                    }
                }
            },
            selectpeople(){
                let that = this;
                // if (that.$limits.fnIsEmpty(that.dataDetail.Part_Code)) {
                //     that.$message.warning('请选择物料！');
                //     return;
                // }
                // let param = {
                // part_code: that.dataDetail.Part_Code,
                // part_version: that.dataDetail.Part_Name,
                // PUBPart_ID: that.dataDetail.Part_ID
                // }
                that.$refs.people.clearInput(true);
            },
            //工序信息填写
            getPeople(data){
                let that = this;
                that.dataDetail.Transact_person = data.name;
            },
            
            selectsupplier(){
                let that = this;
                that.$refs.supplier.clearInput(true);
            },
            getsupplier(data){
                let that = this;
                that.dataDetail.Vender_Code = data.vender_code;
                that.dataDetail.Vender_Name = data.vender_name;
                that.dataDetail.Tax_flag = data.tax_flag;
                that.dataDetail.Currency_Code = data.currency_code;
                if(that.$limits.fnIsEmpty(data.vender_code)){
                    that.IsEditPrice = false;
                }else{
                    if(that.dataDetail.Tax_Rate != data.tax_rate){//税率有变化，重新计算
					//不含税价-->含税价
                    that.dataDetail.Tax_Rate = data.tax_rate;
                    let price = that.dataDetail.Net_unit_price * (1 + that.dataDetail.Tax_Rate/100);
                    that.dataDetail.OldUnitPrice = that.dataDetail.Unit_Price;
					that.dataDetail.Unit_Price = price.toFixed(2);
                    }else{
                        that.dataDetail.OldUnitPrice=null;
                    }
                }
                that.IsEditPrice = true;

            },
            CalTaxPrice(e){
                let that =this;
                that.dataDetail.OldUnitPrice = that.dataDetail.Unit_Price;
                let price = e * (1 + that.dataDetail.Tax_Rate/100);
                that.dataDetail.Unit_Price = price.toFixed(2);

            },
            // 批量选择
            handleSelectionChange(val) {
            let that = this;
            that.multipleSelection = val;
            that.btnauthority();
            },
            // // 批量选择
            // handleSelectionChangeM(val) {
            // //let that = this;
            // this.multipleSelectionMain = val;
            // if(this.multipleSelectionMain.length>0){
            //     if(this.dataDetail.Status == 0)this.btn.btn1  = true;
            //     else this.btn.btn1  = false;
            // }else{
               
            //     this.btn.btn1  = false;
            // }
            // },
            tableRowClassName({ row, rowIndex }) {
            row.index = rowIndex;
            },
            tableRowClassNameM({ row, rowIndex }) {
            row.index = rowIndex;
            },
            //删单
            delall(){
                let that = this;
                if(that.$limits.fnIsEmpty(that.dataDetail.Order_No))return;
                let param = {
                ids: that.dataDetail.Order_No,
                }
                that.$refs.SetBtn.SetOneBtnEnable('del',false);
                that.$http.urlpost('/CostCalc/CostJustView/DelCostJustOrderRecManageExByID', param, function (res) {
                that.$refs.SetBtn.SetOneBtnEnable('del',true);
                if (res.Success == 1) {
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                that.getView()
                that.confirmAdd()
                }
                });


            },
            //删行
            delline() {
            let that = this;
            if(that.multipleSelection.length==0)return;
            let tmpIndex=[];
            if(that.$limits.fnIsEmpty(that.dataDetail.Order_No)){
                // 新建时删除行，不调用接口
                for (let i = that.multipleSelection.length - 1; i >= 0; i--) {
                that.dataDetail.CostJustOrderLine.splice(that.multipleSelection[i].index, 1);
                }
                return;
            }else{
                //编辑时 新加的物料不用调用接口，直接前端删
                for (let i = that.multipleSelection.length - 1; i >= 0; i--) {
                    if(!that.$limits.fnIsEmpty(that.multipleSelection[i].IsNew)){
                    that.dataDetail.CostJustOrderLine.splice(that.multipleSelection[i].index, 1);
                    }else{
                        tmpIndex.push(that.multipleSelection[i]);
                    }
                }
            }
            if(tmpIndex.length==0)return;

            let param = {
            code:that.dataDetail.Order_No,
            ids:'',
            update_time:that.dataDetail.Modify_Time
            }
            for (let i = tmpIndex.length - 1; i >= 0; i--) {
            param.ids = param.ids+tmpIndex[i].Line_No+',';
            }
            param.ids = param.ids.substring(0,param.ids.length-1);
            that.btn.btn1 = false;
            that.$http.urlpost('/CostCalc/CostJustView/DeleteOrderLine', param, function (res) {
            that.btn.btn1 = true;
            if (res.Success == 1) {
                that.$message.success(that.$t('getapi[659]'));//'删除成功'
                that.getDetail(that.dataDetail.Order_No);
            }
            });
            },
            dellineAll(){
                let that = this;              
                if(that.dataDetail.CostJustOrderLine.length==0)return;
                let param = {
                code:that.dataDetail.Order_No,
                ids:'',
                update_time:that.dataDetail.Modify_Time
                }
                for (let i = that.dataDetail.CostJustOrderLine.length - 1; i >= 0; i--) {
                param.ids = param.ids+that.that.dataDetail.CostJustOrderLine[i].Line_No+',';
                }
                param.ids = param.ids.substring(0,param.ids.length-1);
                that.btn.btn1 = false;
                that.$http.urlpost('/CostCalc/CostJustView/DeleteOrderLine', param, function (res) {
                that.btn.btn1 = true;
                if (res.Success == 1) {
                that.$message.success(that.$t('getapi[659]'));//'删除成功'
                that.getDetail(that.dataDetail.Order_No);
                }
                });
            },
            mustclose(){
                let that = this;
                if(that.multipleSelectionMain.length==0){
                    that.$message.warning(that.$t('getapi[8756]'));//"请选择一行数据!"
                    return;
                }
                this.$confirm(that.$t('getapi[8629]'), that.$t('getapi[194]'), {//'你确认要关闭吗?'
                confirmButtonText: that.$t('getapi[1146]'),
                cancelButtonText: that.$t('getapi[2054]'),
                type: 'warning'
                }).then(() => {
                    let param = {
                    code: that.dataDetail.Exclusively_ID,
                    ids: "",
                    update_time: that.dataDetail.Modify_Date
                    }
                    for (let i = that.multipleSelectionMain.length - 1; i >= 0; i--) {
                    param.ids = param.ids+that.multipleSelectionMain[i].Exclusively_ID+',';
                    }
                    param.ids = param.ids.substring(0,param.ids.length-1);
                    param.LangType = that.$processdata.getLang()
                    that.btn.mustclose = false;
                    that.$http.urlpost('/ISS/Order/CloseLines', param, function (res) {
                    that.btn.mustclose = true;
                    if (res.Success == 1) {
                    that.getDetail(that.dataDetail.Exclusively_ID)
                    that.$message.success(that.$t('getapi[4230]'));//关闭成功
                    }
                    });
                }).catch(() => {
                // this.$message({
                // type: 'info',
                // message: '已取消删除'
                // });   
                });


                

            },
            //导入
            imp() {
            let item = {
            //label: '外协价表导入',
			label: '通用导入',
            name: 'exp',
            path: '/exp/12',
            url: '/exp/12',
            icon: 'video-play'
            };
            this.$router.push({ path: '/exp/12' });
            this.$store.commit('selectMenu', item);
            },
            print() {
                //判断状态
                let that = this;
                if(that.$limits.fnIsEmpty(that.dataDetail.Exclusively_ID)){ return; }
                that.$refs.SetBtn.SetOneBtnEnable('print', false);
                that.dloading = true;
                let parm = {
                    po_no: that.dataDetail.Exclusively_ID,
                    HasTaxPrice:that.orderCPrice,
                    TemplateName: '20发外订单.xlsx'
                };
                that.$http.urlpost('/Print/WXPrint', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('print', true);
                    if (res.Success == 1) {
                        let hrefurl = res.Key;
                        window.open(hrefurl);
                    } 
                    that.dloading = false;
                });
            },
            // 导出
            exps() {
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.loading = true;
                that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                that.$http.urlpost(that.expurl, parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                    that.loading = false;
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "RecCostViewInfo",
                    fromname: that.$t('getapi[6653]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            // 保存
            save() {
                let that = this;
                let parm = that.dataDetail;
                that.$refs.SetBtn.SetOneBtnEnable('save', false);
                console.log("2isimportsave"+that.isimportsave)
                parm.isimportsave=that.isimportsave;
                parm.LangType = that.$processdata.getLang()
                that.$http.urlpost('/CostCalc/CostJustView/SaveCostJustOrderRecManageEx', parm, function(res) {
                    if (res.Success == 1) {
                        // that.isimportsave=0;
                        that.$message.success(that.$t('getapi[3153]'));//'保存成功'
                        //that.dataDetail.IsEdit = 1;
                        that.dataDetail.Order_No = res.UniqueNum;
                        that.getDetail(that.dataDetail.Order_No);
                        that.getView();
                        
                    }
                    that.isimportsave=0;
                    that.$refs.SetBtn.SetOneBtnEnable('save', true);
                });
            },
            getDetail(code) {
                let that = this;
                that.dloading = true;
                that.IsEditPrice = true;
                that.IsEdit=false;
                let parm = {
                    Code: code
                };
                that.$http.urlpost(that.detailurl, parm, function (res) {
                    if (res.Success == 1 && res.DataContent != null) {
                        that.dataDetail = res.DataContent.model;
                        that.totalDetail.txtMaterialTotal=res.DataContent.txtMaterialTotal;
                        that.totalDetail.txtManTotal=res.DataContent.txtManTotal;
                        that.totalDetail.txtChargeTotal=res.DataContent.txtChargeTotal;
                        that.totalDetail.txtTotal=res.DataContent.txtTotal;

                        if(that.dataDetail.Order_Status==0)that.IsEdit=true;
                        else that.IsEdit=false;
                        if(that.$limits.fnIsEmpty(that.dataDetail.CostJustOrderLine))that.dataDetail.CostJustOrderLine=[];
                        that.oldDataDetail = JSON.stringify(that.dataDetail)
                        that.$nextTick(function(){
                            that.$processdata.initForm(this.SelectIndex)
                            that.$processdata.initFormRight(this.RightSelectIndex)
                        });
                        that.authority();
                        that.btnauthority()
                    }
                    that.dloading = false;
                });
            },
            //计算含税不含税价格
            caculateTax(){
            let that = this;
            let Change_Rate = that.dataDetail.huilv;
            that.orderAPrice = 0;//税
            that.orderBPrice = 0;//不含税
            that.orderCPrice = 0;//含税
            if(that.$limits.fnIsEmpty(that.dataDetail.CostJustOrderLine)){
                return;
            }
            for(let i=0;i<that.dataDetail.CostJustOrderLine.length;i++){
                let tmqty=0;//数量
                let tmpprice=0;//含税价
                let tmpTaxPrice=0;//不含税价
                let obj = that.dataDetail.CostJustOrderLine[i];
                if(!that.$limits.fnIsEmpty(obj.Line_Qty)&&!that.$limits.fnIsEmpty(obj.line_total_unitprice)&&!that.$limits.fnIsEmpty(obj.line_net_unitprice)){
                    tmqty = obj.Line_Qty;
                    tmpprice = obj.line_total_unitprice;
                    tmpTaxPrice = obj.line_net_unitprice;
                    that.dataDetail.CostJustOrderLine[i].line_total_amount = (tmqty*tmpprice).toFixed(4);
                    that.dataDetail.CostJustOrderLine[i].line_net_amount = (tmqty*tmpTaxPrice).toFixed(4);
                    that.dataDetail.CostJustOrderLine[i].line_total_amount_cny = (tmqty*tmpprice*Change_Rate).toFixed(4);
                    that.dataDetail.CostJustOrderLine[i].line_net_amount_cny = (tmqty*tmpTaxPrice*Change_Rate).toFixed(4);

                }
                that.orderCPrice+=tmqty*tmpprice;
                that.orderBPrice+=tmqty*tmpTaxPrice;

            }
            that.orderAPrice = (that.orderCPrice-that.orderBPrice).toFixed(4);
            that.orderBPrice = that.orderBPrice.toFixed(4);
            that.orderCPrice = that.orderCPrice.toFixed(4);
            },
            handleSelectionChange1(val){
                let that = this;
                that.selectData1 = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData1.push(val[i]);
                }
                that.btnauthority()
            },
            handleSelectionChange2(val){
                let that = this;
                that.selectData2 = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData2.push(val[i]);
                }
                that.btnauthority()
            },
            handleSelectionChange3(val){
                let that = this;
                that.selectData3 = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData3.push(val[i]);
                }
                that.btnauthority()
            },
            handleSelectionChange4(val){
                let that = this;
                that.selectData4 = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData4.push(val[i]);
                }
                that.btnauthority()
            },
            // 生产业务图
            getPro(){
                let that = this
                let data = {}
                if(that.SelectIndex == 0){
                    data = that.selectData[0]
                } else if (that.SelectIndex == 1){
                    data = that.selectData1[0]
                } else if (that.SelectIndex == 2){
                    data = that.selectData2[0]
                } else if (that.SelectIndex == 4){
                    data = that.selectData4[0]
                }
                let item = {
                    label: '生产关系图',
                    name: 'prorelation',
                    path: '/prorelation/sr',
                    url: '/prorelation/sr',
                    params: data,
                    query: data,
                    icon: 'video-play'
                };
                this.$router.push({ path: '/prorelation/sr', query: data });
                this.$store.commit('selectMenu', item);
                this.$limits.cachePage(item)
            },
            //批量删除
            batchDel(){
                let that = this
                let arr = []
                if(that.selectData1.length == 0){
                    that.$message.warning(that.$t('getapi[1158]'))//请选择数据！
                    return
                }
                for(let i = 0;i<that.selectData1.length;i++){
                    arr = [...arr,{
                        sr_code: that.selectData1[i].SR_code,
                    }]
                }
                let parm = {
                    Lists: arr
                }
                that.$http.urlpost('/Pro/SR/SRDelLine', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getView()
                    }
                });
            },
            //批量下达
            batchRelease(){
                let that = this
                let arr = []
                if(that.selectData1.length == 0){
                    that.$message.warning(that.$t('getapi[1158]'))//请选择数据！
                    return
                }
                for(let i = 0;i<that.selectData1.length;i++){
                    arr = [...arr,{
                        sr_code: that.selectData1[i].SR_code,
                    }]
                }
                let parm = {
                    Lists: arr
                }
                that.$http.urlpost('/Pro/SR/SRRelease', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getView()
                    }
                });
            },
            //撤销下达
            releaseToCreate(){
                let that = this
                let parm = {
                    sr_code: that.selectData2[0].SR_code
                }
                that.$http.urlpost('/Pro/SR/SRReleaseToCreate', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getView()
                    }
                });
            },
            //取消
            batchCancel(){
                let that = this
                let arr = []
                if(that.selectData2.length == 0){
                    that.$message.warning(that.$t('getapi[1158]'))//请选择数据！
                    return
                }
                for(let i = 0;i<that.selectData2.length;i++){
                    arr = [...arr,{
                        sr_code: that.selectData2[i].SR_code,
                    }]
                }
                let parm = {
                    Lists: arr
                }
                that.$http.urlpost('/Pro/SR/SRBatchCancel', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getView()
                    }
                });
            },
            //生成
            cancelToCreate(){
                let that = this
                let parm = {
                    sr_code: that.selectData4[0].SR_code,
                }
                that.$http.urlpost('/Pro/SR/SRCancelToCreate', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getView()
                    }
                });
            },
            expStatus(val){
              if(val == 0){
                  return '生成'
              } else if(val == 1){
                  return '下达'
              } else if(val == 2){
                  return '已下单'
              } else if(val == 3){
                  return '取消'
              } else {
                  return ''
              }
            },
            del(){
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            sr_code : that.dataDetail.Head.sr_code,
                            sr_status:that.dataDetail.Head.sr_status
                        }
                        that.$refs.SetBtn.SetOneBtnEnable('del',false);
                        that.$http.urlpost('/Pro/SR/DelSr', parm, function (res) {
                            that.$refs.SetBtn.SetOneBtnEnable('del',true);
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                                that.getView()
                                that.confirmAdd()
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            //获取物料
            selectpart(row) {
                let that = this;
                this.partindex = row.$index;
                that.$refs.part.clearInput(true);
            },
            //委外获取物料弹窗
            selectpartt(){
                let that = this;
                if (that.$limits.fnIsEmpty(that.dataDetail.Part_ID)) {
                    that.$message.warning(this.$t('getapi[8793]'));//'请先选择物料'
                    return;
                }
                let param =  {
                    PUBPart_ID: that.dataDetail.Part_ID
                }
                that.$refs.partt.clearInput(true,param);
            },

            getpart(data){
                let that = this;
                that.Line_No = 1;
                for (let i = 0; i < that.dataDetail.CostJustOrderLine.length; i++) {
                    if (that.dataDetail.CostJustOrderLine[i].Line_No >= that.Line_No) {
                        that.Line_No= that.dataDetail.CostJustOrderLine[i].Line_No + 1;
                    }
                }
                for(let i=0;i<data.length;i++){
                    
                    let Relation_IID_Temp=0;
                    if(!that.$limits.fnIsEmpty(that.dataDetail.Order_No)){
                    Relation_IID_Temp = that.dataDetail.Order_No;
                    }
                    let deti = {
                    IsNew:1,                    
                    Relation_Order_No:Relation_IID_Temp.toString(),
                    Line_No: that.Line_No++,
                    Part_code:data[i].part_code,
                    part_name:data[i].part_name,
                    unit_price:'0',
                    Part_version:data[i].part_version,
                    Category_First_Name:data[i].category_first_name,
                    Category_Second_Name:"",
                    Category_Third_Name:"",
                    Init_Qty:data[i].init_qty,
                    Receive_Qty:data[i].receive_qty,
                    Receive_Material_Cost:data[i].receive_material_cost,
                    Receive_Man_Cost:data[i].receive_man_cost,
                    Receive_Charge_Cost:data[i].receive_charge_cost,
                    Receive_Adjust_Material_Cost:'0',
                    Receive_Adjust_Man_Cost:'0',
                    Receive_Adjust_Charge_Cost:'0',
                    Line_Remark:""
                    
                    };
                    that.dataDetail.CostJustOrderLine.push(deti);
                }

                //that.dataDetail.CostJustOrderLine[that.partindex].Part_code = data.part_code;
                //that.dataDetail.CostJustOrderLine[that.partindex].Item_code = data.item_code;
                
            },
            getSignList(id){
              let that = this
              let parm = {
                  Id: id
              }
                that.$http.urlpost('/Pro/SR/GetSrSignsByPartId', parm, function (res) {
                    if (res.Success == 1) {
                        that.SignList = res.DataContent.DataList
                    }
                });
            },
            selectitem() {
                let that = this;
                that.$refs.item.clearInput(true);
            },
            getitem(data){
                let that = this
                console.log(data)
                that.dataDetail.Head.item_code = data.item_code
            },
            checkDataChange(){
                let that = this
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.CostJustOrderLine.length;i++){
                    delete datacopy.CostJustOrderLine[i]['index']
                }
                let flag =  that.oldDataDetail != JSON.stringify(datacopy)
                return flag
            }
        }
    };
</script>

<style scoped lang="less">
span.title {
	width: 100%;
	display: flex;
	height: 40px;
	line-height: 40px;
}

span.title .el-switch {
	display: inline-block;
	margin: 8px 30px;
}
.box {
	width: 100%;
	.bbl {
		margin: 0px auto 10px;
		white-space: pre;
		span {
            margin-left: 10px;
			min-width: 70px;
			text-align: left;
			line-height: 20px;
			display: inline-block;
			margin-right: 0px;
		}
	}
}
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    /deep/ .green {
        background: #c8ffbb;
    }
    /deep/ .red {
        background: #ff7879;
    }
</style>
